import React from 'react';
import {isEmpty} from "../utils/StringUtils";

class AisinoButtonArea extends React.Component{
    handleModules(buttonModules){
        if(isEmpty(buttonModules)||buttonModules.length===0){
            return "";
        }
        let btnArr=[];
        let index=0;
        buttonModules.forEach(item=>{
            if(!item.props.hidden){
                btnArr.push(
                    <div key={index++} className="space-align-block">
                        {item}
                    </div>
                )
            }
        });
        return btnArr;
    }
    render() {
        return(
            <div className="space-align-container" style={this.props.style}>
                {this.handleModules(this.props.buttonModules)}
            </div>
        )
    }
}
export default AisinoButtonArea